import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = {
  id: "certify1"
};
const _hoisted_3 = {
  class: "swiper-container"
};
const _hoisted_4 = {
  class: "swiper-wrapper",
  id: "fywh"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "listbox"
};
const _hoisted_8 = {
  class: "list"
};
const _hoisted_9 = {
  id: "listul"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "num"
};
const _hoisted_12 = {
  class: "liinnerbox"
};
const _hoisted_13 = {
  class: "img"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "desc"
};
const _hoisted_16 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`exhibiton ${$data.isPc ? 'isPc' : ''}`)
  }, [_createElementVNode("div", {
    class: "fixed",
    style: _normalizeStyle(`transform: scale(${$data.scale})`)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.banners, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      onClick: $event => $options.openUrl(item.itemformdata[3])
    }, [_createElementVNode("img", {
      src: item.itemformdata[2]
    }, null, 8, _hoisted_6), _createElementVNode("h2", null, _toDisplayString(item.itemformdata[1]), 1), _cache[0] || (_cache[0] = _createElementVNode("h3", null, null, -1))], 8, _hoisted_5);
  }), 256))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "swiper-pagination"
  }, null, -1))]), _cache[2] || (_cache[2] = _createElementVNode("input", {
    type: "hidden",
    id: "oldIndex"
  }, null, -1))])]), _createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("h1", {
    class: "animated fadeInUp"
  }, "最受欢迎", -1)), _createElementVNode("div", _hoisted_8, [_createElementVNode("ul", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      onClick: $event => $options.openUrl(item.itemformdata[6])
    }, [_createElementVNode("span", _hoisted_11, _toDisplayString(index + 1), 1), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
      src: item.itemformdata[4]
    }, null, 8, _hoisted_14)]), _createElementVNode("h2", null, _toDisplayString(item.itemformdata.museumName), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(item.itemformdata[3]), 1), _createElementVNode("span", {
      class: _normalizeClass(`zan ${item.isLike ? 'selected' : ''}`),
      id: "41",
      onClick: _withModifiers($event => $options.zan(item, index), ["stop"])
    }, [_createElementVNode("b", null, _toDisplayString(item.itemformdata.likeNum), 1), _cache[3] || (_cache[3] = _createElementVNode("i", null, null, -1))], 10, _hoisted_16)])], 8, _hoisted_10);
  }), 256))])])])], 4)], 2);
}